import { AxiosResponse } from 'axios';

import BaseApi from './BaseApi';

const adjustmentApi = {
  getAgreementDoc(
    token: string,
    payload: {
      adjustmentId: number;
      accountId: number;
      signed: boolean;
    }
  ): Promise<AxiosResponse<string>> {
    return BaseApi.get(
      `api/v1/adjustments/${payload.adjustmentId}/agreement?accountId=${payload.accountId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/pdf',
        },
      }
    );
  },

  initAgreementDoc(
    token: string,
    payload: {
      adjustmentId: number;
      accountId: number;
    }
  ): Promise<AxiosResponse<string>> {
    return BaseApi.post(
      `api/v1/adjustments/${payload.adjustmentId}/agreement?accountId=${payload.accountId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  signAgreementDoc(
    token: string,
    payload: {
      adjustmentId: number;
      accountId: number;
      doc: Blob | string;
    }
  ): Promise<AxiosResponse<string>> {
    const formData = new FormData();
    formData.append('agreement', new Blob());
    return BaseApi.put(
      `api/v1/adjustments/${payload.adjustmentId}/sign?accountId=${payload.accountId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  confirmAgreementDoc(
    token: string,
    payload: {
      adjustmentId: number;
      accountId: number;
    }
  ): Promise<AxiosResponse<string>> {
    return BaseApi.put(
      `api/v1/adjustments/${payload.adjustmentId}/confirm?accountId=${payload.accountId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
};

export default adjustmentApi;
